<div *ngIf="YTUrl" class="container-iframe large-video">
  <iframe
    [src]="YTUrl"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
    class="responsive-iframe large-video"
  >
  </iframe>
</div>
<div *ngIf="externalLink" class="flex">
  <a class="small-video flex flex-column justify-content-center align-items-center py-3" target="_blank" [href]="externalLink">
    <fa-icon [icon]="faVideo"></fa-icon>
    <p-button [label]="'RECORDING.WATCH_IT' | translate" styleClass="p-button-warning text-14 w-7rem"></p-button>
  </a>
</div>
